import { colorForAllocationSlice } from "../config/portfolioAllocationColors";
import { MAIN_PORTFOLIO_COMPOSITION_TITLE } from "../config/portfolioConfig";
import {
  formatAllocationPercent,
  formatMainAllocationEmptyNotice,
  formatMainAllocationFetchNotice,
} from "./portfolioAllocationMessages";
import { resolveActiveLocale } from "./sharmaReportMessages";

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function validName(name) {
  return typeof name === "string" && name.trim() !== "";
}

function buildSeriesName(ctx = {}) {
  const name =
    ctx.portfolioDisplayName != null
      ? String(ctx.portfolioDisplayName).trim()
      : "";
  if (name && name !== MAIN_PORTFOLIO_COMPOSITION_TITLE) {
    return name;
  }
  return MAIN_PORTFOLIO_COMPOSITION_TITLE;
}

function mapPosition(row) {
  const allocation = num(row?.allocation);
  if (allocation == null) {
    return null;
  }
  if (!validName(row?.name)) {
    return null;
  }
  const id = row?.id != null ? String(row.id).trim() : "";
  const y = allocation * 100;
  return {
    name: String(row.name).trim(),
    y,
    id: id || undefined,
    aum: num(row?.aum) ?? undefined,
    percent: y,
    percentLabel: formatAllocationPercent(y),
  };
}

export function adaptPortfolioAllocationPie(json, ctx = {}) {
  const locale = ctx.locale ?? resolveActiveLocale();
  const positions = Array.isArray(json?.allocation_positions)
    ? json.allocation_positions
    : [];
  const mapped = positions.map(mapPosition).filter(Boolean);
  mapped.sort((a, b) => b.y - a.y);
  const colored = mapped.map((item, index) => ({
    ...item,
    color: colorForAllocationSlice(item.id, index),
  }));

  const data = colored.map(({ name, y, id, aum, color }) => ({
    name,
    y,
    id,
    aum,
    color,
  }));

  const legendItems = colored.map(({ id, name, percent, percentLabel, color, aum }) => ({
    id,
    name,
    percent,
    percentLabel,
    color,
    aum,
  }));

  const seriesName = buildSeriesName(ctx);
  const base = {
    kind: "main_allocation_pie",
    seriesName,
    data,
    legendItems,
    type: "pie",
    portfolioApiId: ctx.portfolioApiId ?? undefined,
  };

  if (data.length === 0) {
    return {
      ...base,
      partial: true,
      partialNotice: formatMainAllocationEmptyNotice(locale),
    };
  }

  return base;
}

export function buildFailedMainAllocationPie(err, locale, portfolioDisplayName) {
  return {
    kind: "main_allocation_pie",
    seriesName: buildSeriesName({ portfolioDisplayName }),
    type: "pie",
    data: [],
    legendItems: [],
    partial: true,
    partialNotice: formatMainAllocationFetchNotice(
      locale,
      err?.message || String(err || "")
    ),
  };
}
